<p>update-allergy works!</p>
